<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-form :inline="true" :model="filters" class="filterForm">
				<el-form-item label="编码名称:" label-width="100px" prop="keyName">
					<el-input v-model="filters.keyName" auto-complete="off" class="formItem" size="small" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getGridData" size="small">查询</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="grid_data" height="calc(100vh - 220px)" border highlight-current-row v-loading="listLoading" style="width: 100%;">
			<el-table-column prop="index" label="序号" width="50">
                <template slot-scope="scope">{{scope.$index + 1 }}</template>
            </el-table-column>
			<el-table-column prop="keyName" label="编码名称" width="150"></el-table-column>
			<el-table-column prop="startNumber" label="开头编码" width="150"></el-table-column>
			<el-table-column prop="centerNumberRule" label="中间规则类型" width="200" :formatter="showRuleName"></el-table-column>
			<el-table-column prop="endNumber" label="结尾流水号" width="150"></el-table-column>
			<el-table-column label="操作" width="250">
				<template scope="scope">
					<el-button size="small" @click="editInfo(scope.$index, scope.row)">编辑</el-button>
				</template>
			</el-table-column>
		</el-table>

		<pagination :totalPage="total" :currentPage="filters.page" :pageSize="filters.rows"
			@pageSizeCallBack="handleSizeChange" @currentPageCallBack="handleCurrentChange"></pagination>

		<addsave :showTitle="showTitle" :dialogAddShow="dialogAddShow" :mid="mid" @saveCallBack="saveCallBack"
			@getVisible="closeDialog"></addsave>
	</section>
</template>
<script>
import pagination from '@/components/common/pagination.vue'
import addsave from '../basic/basic_primaryadd.vue'
export default {
	components: { addsave,pagination },
	data() {
		return {
			filters: {
				keyName: '',
				rows: 10,
				page: 1
			},
			grid_data: [],
			total: 0,
			listLoading: false,
			sels: [],//列表选中列
			showTitle: "",
			dialogAddShow: false,
			mid: 0
		}
	},
	methods: {
		showRuleName(row, column, cellValue, index){
			let names=['无','年月日（yyyyMMdd)','年月日（yyMMdd)','年月（yyyyMM)','年月（yyMM)','年（yyyy）']
			return names[Number(cellValue)];
		},
		handleSizeChange(val) {
			this.filters.rows = val;
			this.getGridData();
		},
		handleCurrentChange(val) {
			this.filters.page = val;
			this.getGridData();
		},
		//获取列表
		getGridData() {
			this.listLoading = true;
			let formData = this.$util.jsonToForm(this.filters);
			this.$axios.post("/basic/getbasic_primarylist", formData).then(res => {
				this.listLoading = false;
				this.total = res.data.total;
				this.grid_data = res.data.data;
			});
		},
		addInfo: function () {
			this.showTitle = "新增单号编码";
			this.dialogAddShow = true;
			this.mid = 0;
		},
		editInfo: function (index, row) {
			this.showTitle = "编辑单号编码";
			this.dialogAddShow = true;
			this.mid = row.id;
		},
		saveCallBack: function () {
			this.dialogAddShow = false;
			if (this.mid == 0) {
				this.handleCurrentChange(1);
			}
			else {
				this.getGridData();
			}
		},
		closeDialog: function (bool) {
			this.dialogAddShow = bool
		},
	},
	mounted() {
		this.getGridData();
	}
}

</script>

<style scoped></style>

